import React, { useEffect, useState } from "react";

const DateTimeDisplay = ({ value }) => {
  const [display, setDisplay] = useState("");

  useEffect(() => {
    if (!value) return;

    const date = new Date(value);

    const formatDate = (d) =>
      d.toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });

    const computeTimeAgo = () => {
      const now = new Date();
      const seconds = Math.floor((now - date) / 1000);

      const intervals = {
        year: 31536000,
        month: 2592000,
        day: 86400,
        hour: 3600,
        minute: 60,
      };

      for (let key in intervals) {
        const interval = Math.floor(seconds / intervals[key]);
        if (interval >= 1) {
          return `${interval} ${key}${interval > 1 ? "s" : ""} ago`;
        }
      }
      return "just now";
    };

    const updateDisplay = () => {
      setDisplay(`${formatDate(date)} (${computeTimeAgo()})`);
    };

    updateDisplay(); // initial render

    const timer = setInterval(updateDisplay, 60000); // refresh every 1 min
    return () => clearInterval(timer); // cleanup
  }, [value]);

  return <span>{display || "-"}</span>;
};

export default DateTimeDisplay;